module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-big"
  }, [_c('el-row', {
    staticClass: "box-b",
    staticStyle: {
      "width": "80%",
      "margin": "0 auto"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('p', [_vm._v("文件列表")]), _vm._v(" "), _c('ul', {
    staticClass: "ull"
  }, _vm._l((_vm.fileLists), function(m, index) {
    return _c('li', {
      key: index,
      class: {
        activess: _vm.activeli === index
      },
      attrs: {
        "title": _vm.formatPlanDoc(m.type)
      },
      on: {
        "click": function($event) {
          _vm.fileclick(m, index)
        }
      }
    }, [_c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [(m.required) ? _c('i', {
      staticClass: "text_red"
    }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "iconfont icon-wenjian-copy1",
      class: {
        'activess2': _vm.plandocState[m.type]
      }
    }), _vm._v("\n            " + _vm._s(_vm.formatPlanDoc(m.type)))])])
  })), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin": "20px 0 0 20px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.addFile
    }
  }, [_vm._v("添加其他附件")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0px 0px 15px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.downloadTemplate
    }
  }, [_vm._v("下载备案表模板")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "type": "text"
    }
  }, [_vm._v("\n          查看示例\n          "), _c('viewer', {
    staticClass: "seeBigImg",
    attrs: {
      "images": _vm.photo
    }
  }, _vm._l((_vm.photo), function(src, index) {
    return _c('img', {
      key: index,
      attrs: {
        "src": src
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('pdf', {
    ref: "pdf",
    attrs: {
      "src": _vm.fileaddress,
      "activeData": _vm.activeData
    },
    on: {
      "changeFile": _vm.changeFile,
      "onError": _vm.onError,
      "onChange": _vm.onChange,
      "downloadTemplate": _vm.downloadTemplate
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "title": "文件上传中",
      "visible": _vm.dialogVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./../../../static/img/2.gif"),
      "height": "64",
      "width": "64"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.abortUpload();
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("终止上传")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "示例",
      "visible": _vm.imgshow,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.imgshow = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.imageUrl,
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e2d0e78","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/weather/govUpload.vue
// module id = 1270
// module chunks = 2